import React, { useEffect } from "react";
import logo from "./logo.png";

export default function SuccessScreen({ page, redirectUrl }) {
    useEffect(() => {
        if (page === "success" && redirectUrl !== null) {
            window.parent.postMessage({ url: redirectUrl, event: "Submit" },
                "*"
            );
        }
    }, [page]);

    return (
        <>
            {redirectUrl === null && (
                <div className="flex flex-col justify-center items-center min-h-screen p-4 box-border text-center">
                    <h3 className="text-xl font-semibold mb-4">
                        Thank You! Your Submission Has Been Received!
                    </h3>
                </div>
            )}
        </>
    );
}
